(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purely-desi-honey-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.PDHoneyBanner) {
    document.querySelectorAll('[data-pdh-banner]').forEach(window.PDHoneyBanner.init);
    return;
  }
  function init(root) {
    if (!root || root.pdhCleanup) return;
    const q = selector => root.querySelector(selector);
    const picks = Array.from(root.querySelectorAll('[data-pdh-pick]'));
    const rail = q('[data-pdh-products]');
    const traveller = q('[data-pdh-traveller]');
    const carried = q('[data-pdh-carried]');
    const speech = q('[data-pdh-speech]');
    const message = q('[data-pdh-message]');
    const confetti = q('[data-pdh-confetti]');
    const pauseButton = q('[data-pdh-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const on = (node, type, fn) => node?.addEventListener(type, fn, { signal: controller.signal });
    const animations = new Set();
    const timers = new Set();
    let paused = reduced.matches;
    let destroyed = false;
    let journey = null;
    let deliveryToken = 0;
    let greetingToken = 0;
    let selected = picks[0];
    let observer;
    let resizeObserver;
    const later = (fn, time) => { const id = setTimeout(() => { timers.delete(id); if (!destroyed) fn(); }, time); timers.add(id); return id; };
    const announce = text => { q('[data-pdh-announcement]').textContent = text; };
    function updateArrows() {
      if (!rail) return;
      const overflow = rail.scrollWidth - rail.clientWidth > 5;
      q('[data-pdh-scroll-controls]').hidden = !overflow;
      q('[data-pdh-prev]').disabled = rail.scrollLeft <= 3;
      q('[data-pdh-next]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
    }
    function clearParticles() {
      animations.forEach(animation => animation.cancel());
      animations.clear();
      confetti.replaceChildren();
    }
    function burst() {
      if (paused || document.hidden || !Element.prototype.animate) return;
      clearParticles();
      for (let i = 0; i < 26; i++) {
        const dot = document.createElement('i');
        dot.style.background = ['#f3c46b', '#ffdf9d', '#e58f4a'][i % 3];
        confetti.appendChild(dot);
        const x = (Math.random() - .5) * 340;
        const y = -70 - Math.random() * 130;
        const animation = dot.animate([
          { transform: 'translate(0,0) rotate(0)', opacity: 1 },
          { transform: `translate(${x * .7}px,${y}px) rotate(100deg)`, opacity: 1, offset: .45 },
          { transform: `translate(${x}px,130px) rotate(280deg)`, opacity: 0 }
        ], { duration: 1700 + Math.random() * 700, easing: 'cubic-bezier(.2,.6,.4,1)' });
        animations.add(animation);
        animation.finished.then(() => { animations.delete(animation); dot.remove(); }).catch(() => {});
      }
    }
    function greet() {
      const token = ++greetingToken;
      message.classList.add('is-visible');
      speech.classList.add('is-visible');
      announce('Ganpati Bappa Morya! Wishing you a joyful Ganesh Utsav.');
      burst();
      later(() => { if (token === greetingToken) { message.classList.remove('is-visible'); speech.classList.remove('is-visible'); } }, 3200);
    }
    async function deliver(initial = false) {
      const token = ++deliveryToken;
      journey?.cancel(); journey = null;
      root.classList.remove('is-delivering');
      speech.classList.remove('is-visible');
      if (paused || document.hidden || !traveller.animate) return;
      root.classList.add('is-delivering');
      journey = traveller.animate([
        { transform: 'translateX(-180px)', opacity: 0 },
        { transform: 'translateX(-140px)', opacity: 1, offset: .16 },
        { transform: 'translateX(0)', opacity: 1 }
      ], { duration: initial ? 2400 : 1900, easing: 'linear' });
      try { await journey.finished; } catch { return; }
      if (destroyed || token !== deliveryToken) return;
      journey = null;
      root.classList.remove('is-delivering');
      speech.classList.add('is-visible');
      later(() => { if (token === deliveryToken) speech.classList.remove('is-visible'); }, 2600);
    }
    function choose(pick) {
      selected = pick;
      picks.forEach(item => { const active = item === pick; item.classList.toggle('is-selected', active); item.setAttribute('aria-pressed', String(active)); });
      q('[data-pdh-title]').textContent = pick.dataset.pdhTitle;
      q('[data-pdh-shop]').href = pick.dataset.pdhUrl;
      const src = pick.dataset.pdhImage;
      carried.hidden = !src;
      q('[data-pdh-jar]').hidden = Boolean(src);
      if (src) carried.src = src; else carried.removeAttribute('src');
      announce(`Mushak brings ${pick.dataset.pdhTitle}. Use Shop this honey to see sizes and details.`);
      deliver();
    }
    function syncMotion() {
      root.classList.toggle('is-paused', paused);
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.textContent = paused ? 'Play animation' : 'Pause animation';
      if (paused) { ++deliveryToken; journey?.cancel(); journey = null; root.classList.remove('is-delivering'); clearParticles(); }
    }
    picks.forEach(pick => {
      pick.setAttribute('role', 'button');
      pick.setAttribute('aria-pressed', String(pick === selected));
      pick.setAttribute('aria-label', `Let Mushak bring ${pick.dataset.pdhTitle}`);
      on(pick, 'click', event => { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); choose(pick); });
      on(pick, 'keydown', event => { if (event.key === ' ') { event.preventDefault(); choose(pick); } });
    });
    on(carried, 'error', () => { carried.hidden = true; q('[data-pdh-jar]').hidden = false; });
    on(q('[data-pdh-mushak]'), 'click', greet);
    on(q('[data-pdh-celebrate]'), 'click', greet);
    on(pauseButton, 'click', () => { paused = !paused; syncMotion(); if (!paused) deliver(); });
    on(reduced, 'change', event => { paused = event.matches; syncMotion(); });
    on(q('[data-pdh-prev]'), 'click', () => rail?.scrollBy({ left: -rail.clientWidth * .75, behavior: paused ? 'auto' : 'smooth' }));
    on(q('[data-pdh-next]'), 'click', () => rail?.scrollBy({ left: rail.clientWidth * .75, behavior: paused ? 'auto' : 'smooth' }));
    on(rail, 'scroll', updateArrows);
    on(document, 'visibilitychange', () => { if (journey && !paused) document.hidden ? journey.pause() : journey.play(); if (document.hidden) clearParticles(); });
    if ('ResizeObserver' in window && rail) { resizeObserver = new ResizeObserver(updateArrows); resizeObserver.observe(rail); } else on(window, 'resize', updateArrows);
    pauseButton.hidden = false;
    q('[data-pdh-celebrate]').hidden = false;
    if (picks.length) q('[data-pdh-choice-hint]').hidden = false;
    syncMotion(); updateArrows();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); if (!destroyed) deliver(true); } }, { threshold: .2 });
      observer.observe(root);
    } else deliver(true);
    root.pdhCleanup = () => {
      destroyed = true; controller.abort(); observer?.disconnect(); resizeObserver?.disconnect();
      journey?.cancel(); clearParticles(); timers.forEach(clearTimeout); timers.clear();
      delete root.pdhCleanup;
    };
  }
  window.PDHoneyBanner = { init };
  document.querySelectorAll('[data-pdh-banner]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pdh-banner]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-pdh-banner]').forEach(root => root.pdhCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
